<div class="zoneCard__container locationCArd__container  m-3">
    <img class="zoneCard__locationIcon" src="../../../../assets/Images/organisation-structure/Zone.svg" alt="zone location">
    <div class="zoneCard__zoneDetails">
        <div class="zoneCard__title">North Zone</div>
        <div class="zoneCard__description">150 users</div>
    </div>
</div>